<div class="products-container row">
  <ng-container *ngFor="let product of productsByCategory">
    <lib-product-card class="col-lg-4" (detailsClickEvent)="onDetailsClick($event)" [product]="product"
      [showDetailsButtonCaption]="showDetailsButtonCaption">
      <ng-container *ngTemplateOutlet="templateRef; context: {$implicit: product}"></ng-container>
      <div class="notification-message-wrapper">
        <div [ngClass]="{'display': (product.productId === productId), 'error-message': (hasError && showNotification), 'success-message': (!hasError && showNotification)}" class="col-lg-12 notification-message">
          <span> {{ notificationMessage | injectedText | async }}</span>
          <a (click)="fireNavigateToCartEvent()"> {{'modeso_cart_added-to-cart_go-to-cart' | injectedText | async}} </a>
        </div>
      </div>
    </lib-product-card>

  </ng-container>
</div>